'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useClickOut } from '@websolutespa/bom-mixer-hooks';
import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import style from './page-intro.module.scss';

export const PageIntro: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const {
    PageContext,
    PageDictate,
    PageMenu,
    PageStop,
    PageStreamingIndicator,
    PageSubmit,
    PageSynthesis,
    PageTextarea,
    PageUpload,
  } = useLlm(state => state.components);
  const app = useLlm(state => state.app);
  const streaming = useLlm(state => state.streaming);
  const opened = useLlmView(state => state.opened);
  const { open } = useLlmView(state => state.actions);

  useClickOut(ref, (event) => {
    const className = (event.target as HTMLElement)?.getAttribute('class') || '';
    // console.log('useClickOut', className);
    if (className.indexOf('llm') === -1 && opened) {
      open();
    }
  });

  if (!app) {
    return;
  }

  const contents = app.contents;
  const extendedWelcomeText = contents.extendedWelcomeText;

  return (
    <section className={style.intro}>
      <div className={style.container}>
        <div className={style.content}>
          <div className={style.head}>
            {extendedWelcomeText && (
              <h1 className={style.title} dangerouslySetInnerHTML={{ __html: extendedWelcomeText }} />
            )}
          </div>
          <section ref={ref} className={style.prompt} aria-label="Prompt">
            <div className={style.inner}>
              <form className={getClassNames(style.form, '-form')} onSubmit={(event: React.FormEvent) => event.preventDefault()}>
                <div className={getClassNames(style.control, {
                  [style.streaming]: streaming,
                })}>
                  <PageStreamingIndicator />
                  <PageTextarea />
                </div>
                {streaming ? (
                  <PageStop />
                ) : (
                  <PageSubmit />
                )}
              </form>
              <div className={style.actions}>
                <div className={style.left}>
                  <PageMenu />
                </div>
                <div className={style.right}>
                  <PageUpload />
                  <PageContext />
                  <PageDictate />
                  <PageSynthesis />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};
